(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.matchMedia('(hover: hover)').matches) return;

    document.addEventListener(
      'click',
      (event) => {
        const media = event.target.closest('[data-flip]');
        if (!media) return;

        if (!media.classList.contains('is-flipped')) {
          media.classList.add('is-flipped');
          event.preventDefault();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
      const drawer = document.getElementById('SizeGuideDrawer');
      const closeButton = document.querySelector('[data-size-guide-close]');
      if (!drawer) return;

      closeButton?.addEventListener('click', () => drawer.close());
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) drawer.close();
      });

      const unitTabs = Array.from(drawer.querySelectorAll('[data-unit-tab]'));
      const unitPanels = {
        cm: document.getElementById('SizeGuideTableCm'),
        in: document.getElementById('SizeGuideTableIn'),
      };

      function selectUnit(unit) {
        unitTabs.forEach((tab) => {
          const isSelected = tab.dataset.unitTab === unit;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
          tab.classList.toggle('is-active', isSelected);
        });
        Object.entries(unitPanels).forEach(([unitKey, panel]) => {
          if (panel) panel.hidden = unitKey !== unit;
        });
      }

      unitTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectUnit(tab.dataset.unitTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = unitTabs[(index + step + unitTabs.length) % unitTabs.length];
          next.focus();
          selectUnit(next.dataset.unitTab);
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
